import PromiseWorker from 'promise-worker';

const baseWorker = new Worker(new URL('./worker.js', import.meta.url));

const tasksWorker = new PromiseWorker(baseWorker);

export { tasksWorker };
